export const FormInteractiveLogicWidgetId = 'FormInteractiveLogic';

export enum FormInteractiveLogicWidgetAttributes {
  FORM_CONTROL_NAME = 'formControlName',
  FORM_CONTROL_VALUE = 'formControlValue',
  TARGET_FORM_GROUP = 'targetFormGroup',
  HIDE_FROM_GROUP_WHEN_VALUE_MATCHES = 'hideFormGroupWhenValueMatches',
}
